import { useCallback } from 'react';
import {
  Camera,
  CameraResultType,
  CameraSource,
  Photo,
} from '@watchduty/camera';
import { useAuthState } from 'state/useAuthState';
import { isAuthorizedUser } from 'shared/utils';

/**
 * Launches the native camera. Internal users and reporters may also pick from the photo library;
 * everyone else is limited to taking a new photo. Resolves to null if cancelled or failed.
 */
export const useTakePhoto = (): (() => Promise<Photo | null>) => {
  const {
    user,
    permissions: { isInternalUser },
  } = useAuthState();
  const canPickFromLibrary = isInternalUser || isAuthorizedUser(user);

  return useCallback(async () => {
    try {
      return await Camera.getPhoto({
        quality: 90,
        allowEditing: false,
        saveToGallery: true,
        width: 1500,
        resultType: CameraResultType.Uri,
        source: canPickFromLibrary ? CameraSource.Prompt : CameraSource.Camera,
      });
    } catch (e) {
      return null;
    }
  }, [canPickFromLibrary]);
};
